/**
 * @generated SignedSource<<6dbe057c43272742b66eaa5c5b9d4422>>
 * @relayHash 13e9ccffd4783d3489f7fdc0bdb79076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type NotificationsButtonQuery$variables = Record<PropertyKey, never>;
export type NotificationsButtonQuery$data = {
  readonly notifications: {
    readonly unseenNotificationCount: number;
  } | null | undefined;
};
export type NotificationsButtonQuery = {
  response: NotificationsButtonQuery$data;
  variables: NotificationsButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "InfluentsNotificationQuery",
    "kind": "LinkedField",
    "name": "notifications",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "unseenNotificationCount"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NotificationsButtonQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationsButtonQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "13e9ccffd4783d3489f7fdc0bdb79076",
    "id": "9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8",
    "metadata": {},
    "name": "NotificationsButtonQuery",
    "operationKind": "query",
    "text": "query NotificationsButtonQuery{notifications{unseenNotificationCount}}"
  }
};
})();

(node as any).hash = "942a544fd139c706378825d031824679";

export default node;
